<div class="orders-list"
     [mmTestId]="'ORDER_LIST.CONTAINER'">
    <div class="orders-list__container">
        <div *ngIf="!(loading$ | async) && !(orders$ | async)?.length"
             [mmTestTarget]="'list-empty-state'"
             class="orders-list__empty-state">
            <span>{{ 'PAGES.ACCOUNT.ORDERS_HISTORY.NO_ORDERS_IN_LIST' | translate }}</span>
        </div>

        <div *ngIf="loading$ | async"
             [mmTestTarget]="'list-spinner'"
             class="orders-list__spinner-wrapper">
            <mm-spinner diameter="50"></mm-spinner>
        </div>

        <div *ngIf="(orders$ | async)?.length"
             class="orders-list__content orders-list__content__tabs">
            <app-order-history-list-item *ngFor="let order of (orders$ | async); let first = first; let last = last"
                                         [order]="order"
                                         [isContactEmailFeatureEnabled]="isContactEmailFeatureEnabled$ | async"
                                         [isGetInvoiceFeatureEnabled]="isGetInvoiceFeatureEnabled$ | async"
                                         [isFirstOrder]="first"
                                         [isLastOrder]="last"
                                         [isMobileOrTablet]="isMobileOrTablet"
                                         [isBuyAgainButtonEnable] = "isBuyAgainEnable"
                                         [isSubsidiaryAccount]="isSubsidiary"
                                         [isEnabledPaymentMethodCode]="isEnabledPaymentMethodCode$ | async">
            </app-order-history-list-item>
        </div>

        <div *ngIf="isAllowedLoadMoreBtn"
             class="orders-list__load-more-btn">
            <button mm-button
                    type="button"
                    [color]="'secondary'"
                    [loading]="loading$ | async"
                    [mmTestTarget]="'orders-load-more-button'"
                    (click)="loadMore()">
                {{ 'PAGES.ACCOUNT.ORDERS_HISTORY.LOAD_MORE_BUTTON' | translate }}
            </button>
        </div>
    </div>
</div>
